import { useSelector } from 'react-redux';

import { Viewport } from '@app/features/apply-react-signing/components/FieldRenderer/types';
import SignerMouseFieldPlaceholder from '@app/features/apply-react-signing/components/FieldSetupStep/MouseFieldPlaceholder';
import RequesterMousePlaceholder from '@app/features/apply-react-signing/components/FieldSetupStep/RequesterMousePlaceholder';
import { pageViewportSizesSelector, scaleSelector } from '@app/libs/reactPdfJs/store/selectors';

function MouseFieldPlaceholder() {
  const scale = useSelector(scaleSelector);
  const pageViewportSizes = useSelector(pageViewportSizesSelector) as Viewport[];

  return (
    <>
      <RequesterMousePlaceholder scale={scale} viewports={pageViewportSizes} />
      <SignerMouseFieldPlaceholder scale={scale} viewports={pageViewportSizes} />
    </>
  );
}

export default MouseFieldPlaceholder;
